/**
增加缓存请求模块-基本功能添加缓存（还不能投入使用）
0.封装缓存请求模块，兼容目前请求参数方式。
1.根据请求全路径（包括参数）作为缓存key。
2.缓存到sessionStore.
3.30秒内缓存时间。（可配置根据情况进行调整）
ver 1.0.0
author：liqiannan
*/

var cacheRequest = {}

cacheRequest.defaultOption = {
  maxLenght: 5,
  cacheRequestArr: [],
  timeInterver: [], //存储计时变量名
  lastRequest: '',
  cacheSaveTime: 30000, //缓存保持时间
}

/*
Function requestData 请求数据
[param] type:请求类型 String
[param] url: 请求地址 String
[param] param：请求参数 Object
[param] vue: 当前vue对象 Object
*/
cacheRequest.getCatchData = function (type, url, param, vue, cacheSaveTime) {
  var that = this
  if (cacheSaveTime) this.defaultOption.cacheSaveTime = cacheSaveTime
  return new Promise(function (resolve, reject) {
    //key=type_url_param
    var key = `${type}_${url}`
    if (param) key = `${type}_${url}_${JSON.stringify(param)}`
    var data = that.searchCacheKey(key)
    that.getCatchDataRec(data, type, url, param, vue, resolve, reject, key)
  })
}

cacheRequest.requestData = function (type, url, param, vue, resolve, reject, key) {
  let that = this
  var cacheDataEntity = {
    status: 'wait', //wait:表示已请求数据，等到返回。//done:表示数据已经返回完成。
  }
  that.setCatchData(key, JSON.stringify(cacheDataEntity)) //设置缓存
  // 处理请求方式为get时, 传值为object的情况
  let _param = type === 'post' ? param : { params: param }
  vue.$axios[type](url, _param)
    .then((res) => {
      var cacheDataEntity = {
        status: 'done', //wait:表示已请求数据，等到返回。//done:表示数据已经返回完成。
        time: new Date().getTime(),
        data: res,
      }
      that.setCatchData(key, JSON.stringify(cacheDataEntity)) //设置缓存
      resolve(res)
    })
    .catch((err) => {
      reject(err)
    })
}

cacheRequest.getCatchDataRec = function (data, type, url, param, vue, resolve, reject, key) {
  //第1一次请数据。
  if (!data) {
    cacheRequest.requestData(type, url, param, vue, resolve, reject, key)
    return
  }

  //已经在请求中了，等待500毫米以后，在来从事。
  if (data && data.status == 'wait') {
    var that = this
    var setTimeoutKey = setTimeout(function () {
      var data = that.searchCacheKey(key)
      that.getCatchDataRec(data, type, url, param, vue, resolve, reject, key)
      clearTimeout(setTimeoutKey)
      // console.log(key+"=============================================>:清除成功");
    }, 500)
  }

  //请求成功
  if (data && data.status == 'done') {
    var isExpired = this.isExpired(data.time)
    if (isExpired) {
      //缓存过期
      this.removeItem(key)
      this.requestData(type, url, param, vue, resolve, reject, key)
      return
    } else {
      //如果没有过期，返回缓存中的数据。
      resolve(data.data)
    }
  }
}

//计时模块
cacheRequest.isExpired = function (time) {
  var curTime = new Date().getTime()
  if (curTime - time > this.defaultOption.cacheSaveTime) {
    return true
  } else {
    return false
  }
}

//设置缓存
cacheRequest.setCatchData = function (key, data) {
  this.defaultOption.cacheRequestArr.push(key)
  sessionStorage.setItem(key, data)
}

//返回缓存数据
cacheRequest.searchCacheKey = function (key) {
  var item = sessionStorage.getItem(key)
  if (item) {
    return JSON.parse(item)
  } else {
    return null
  }
}

// 删除缓存(支持删除指定缓存，或全部缓存)
cacheRequest.removeItem = function (key = null) {
  if (key) {
    var index = this.defaultOption.cacheRequestArr.indexOf(key)
    this.defaultOption.cacheRequestArr.splice(index, 1)
    sessionStorage.removeItem(key)
    return
  }
  for (var i = 0; i < this.defaultOption.cacheRequestArr.length; i++) {
    sessionStorage.removeItem(this.defaultOption.cacheRequestArr[i])
  }
}
export default cacheRequest
